import React from "react";
import { Col } from "react-bootstrap";
import { Container } from "reactstrap";

export default class About extends React.Component {
    render() {
        return (
            <div style={styles.aboutContainer} className="aboutContainer">
                <Container>
                    <Col xs={12} sm={12} md={12} lg={12} style={styles.aboutMainIntroContainer} className="aboutMainIntroContainer">
                        <div style={styles.myImageContainer}>
                            <img style={styles.myImage} src='https://firebasestorage.googleapis.com/v0/b/portfolio-336c8.appspot.com/o/img.jpg?alt=media&token=e37f07d1-2119-462b-bc67-7e4da048f676' alt="My Image" />
                        </div>
                        <h3 style={styles.mainIntroFLine}>hello, my name is ahsan</h3>
                        <p style={styles.mainIntroPara}>I’m full stack developer, I’m willing person to create productivity products. I’m the tech loving person and I’m also the instructor at YouTube and Udemy and also in the process to learn AI and different revolutionary hot technologies.
                    <br /><br />
                            I’m currently able to create some cool web apps (REACTjS), hybrid applications, websites and also back-end.
                    <br /><br />
                            And I’m very interesting person in investing and marketing.
                    <br /><br />
                            I’m very interested in creating smart homes, smart offices and smart factories using IOT and various other technologies.
</p>
                    </Col>
                </Container>
            </div>
        );
    }
}

const styles = {
    aboutContainer: {
        height: 600,
        backgroundColor: "#232323",
        fontFamily: "Roboto, sans-serif",
        textAlign: 'center',
        paddingBottom: 100
    },
    aboutMainIntroContainer: {
        padding: "100px 80px",
        paddingRight: "180px"
    },
    mainIntroFLine: {
        fontSize: 30,
        color: "#f1f1f1",
        fontWeight: 500,
        textTransform: "uppercase",
        marginBottom: 50
    },
    mainIntroPara: {
        color: "#929292",
        fontSize: 16
    },
    myImageContainer: {
        width: 150,
        height: 150,
        borderRadius: '50%',
        margin: '0px auto'
    },
    myImage: {
        width: 'inherit',
        height: 'inherit',
        borderRadius: '50%'
    }
};


// WEBPACK FOOTER //
// ./src/Components/about.jsx